import React from "react";
import { downArrow, download } from "../../common/svg";
import SecureImage from "../../components/BucketImage/Image";
const ReportButton = () => {
  return (
    <button className="border border-[#EAEAEA] rounded-[20px] w-[140px] flex items-center justify-center">
      <div className="flex items-center gap-2">
        <SecureImage
          
          fileKey={download}
          alt="header icon"
          width="20px"
        />
        <p>Reports</p>
        <SecureImage
          
          fileKey={downArrow}
          alt="header icon"
          width="20px"
        />
      </div>
    </button>
  );
};

export default ReportButton;
